import {
  SearchActionType,
  SearchNameType,
  SearchTypeTypes,
} from '../../../types/tracking-search';

export type SearchEvent = {
  GA4: {
    event: 'search';
    label: string;
    name: SearchNameType;
    action: SearchActionType;
    search_term_completed: string;
    search_destination: string;
    search_type: SearchTypeTypes;
    search_id?: string;
    search_version?: string;
  };
};

export type trackSearchParams = {
  label: string;
  name: SearchNameType;
  searchTermCompleted: string;
  action: SearchActionType;
  searchDestination: string;
  searchType: SearchTypeTypes;
  searchId?: string;
  searchVersion?: string;
};

export const trackSearch = ({
  label,
  name,
  searchTermCompleted,
  action,
  searchDestination,
  searchType,
  searchId,
  searchVersion,
}: trackSearchParams): SearchEvent => {
  const eventGA4: SearchEvent['GA4'] = {
    event: 'search',
    label,
    action,
    name,
    search_term_completed: searchTermCompleted,
    search_destination: searchDestination,
    search_type: searchType,
    search_id: searchId,
    search_version: searchVersion,
  };

  return {
    GA4: eventGA4,
  };
};
